'use es6';

import { createSelector } from 'reselect';
import { SYSTEM_FONT_VALUES } from 'EmailEditorUI/constants/TemplateSettingsConstants';
import { DEFAULT_LINK_COLOR, WEBFONTS_IMPORT, STYLE_SHEET, MOBILE_STYLE_SHEET, DEFAULT_LINE_HEIGHT } from 'EmailEditorUI/lib/TemplateSettingsConstants';
import { getWebfonts } from 'EmailEditorUI/redux/selectors/FontSelectors';
import { getEffectiveStyleSettings } from 'EmailEditorUI/redux/selectors/styleSettingsSelectors';
import { compileStylesheet } from 'EmailEditorUI/utils/styleUtils';
function interpolate(template, styleSettings) {
  const backgroundImage = styleSettings.background_image;
  const backgroundImageType = styleSettings.background_image_type || 'REPEAT';
  if (backgroundImage) {
    styleSettings.background_image = styleSettings.background_image === 'none' ? 'none' : `url('${styleSettings.background_image}')`;
    styleSettings.background_size = backgroundImageType === 'STRETCH' ? '100% 100%' : '';
    styleSettings.background_repeat = backgroundImageType === 'REPEAT' ? 'repeat' : 'no-repeat';
    styleSettings.background_position = backgroundImageType === 'STRETCH' ? 'center' : '';
  }
  return compileStylesheet(template, styleSettings);
}
function _getOverrideableStyleSheetContent(styleSettings, webfonts) {
  var _effectiveSettings$mo;
  let styleSheet = STYLE_SHEET;
  const effectiveSettings = styleSettings.toJS();
  if (Object.keys(webfonts).length) {
    styleSheet = WEBFONTS_IMPORT + styleSheet;
    effectiveSettings.fontsList = Object.keys(webfonts).filter(font => !SYSTEM_FONT_VALUES[font]).map(font => `${font}|${font}:i,b,bi`).join('|');
  }
  effectiveSettings.body_border_width || (effectiveSettings.body_border_width = '1');
  effectiveSettings.computed_links_font_color = effectiveSettings.links_font.color || DEFAULT_LINK_COLOR;
  effectiveSettings.computed_links_font_style = effectiveSettings.links_font.italic ? 'italic' : 'normal';
  effectiveSettings.computed_links_font_weight = effectiveSettings.links_font.bold ? 'bold' : 'normal';
  effectiveSettings.computed_links_text_decoration = effectiveSettings.links_font.underline === false ? 'none' : 'underline';
  effectiveSettings.primary_font_line_height || (effectiveSettings.primary_font_line_height = DEFAULT_LINE_HEIGHT);
  styleSheet = interpolate(styleSheet, effectiveSettings);
  styleSheet += interpolate(MOBILE_STYLE_SHEET, (_effectiveSettings$mo = effectiveSettings.mobile_settings) !== null && _effectiveSettings$mo !== void 0 ? _effectiveSettings$mo : {});
  return styleSheet;
}
export const getOverrideableStylesheetContent = createSelector([getEffectiveStyleSettings, getWebfonts], _getOverrideableStyleSheetContent);
export const processStylesheet = (styleSheetContent, styles) => {
  const stylesheet = styles.sheet;
  while (stylesheet.cssRules.length > 0) {
    stylesheet.deleteRule(0);
  }
  const importRegex = /@import.*?["']([^"']+)["'].*?;/gm;
  const cssImports = styleSheetContent.match(importRegex) || [];
  const otherRules = styleSheetContent.replace(importRegex, '').split('}').filter(rule => rule.trim() !== '').map(rule => `${rule.trim()}}`);
  [...cssImports, ...otherRules].forEach(rule => {
    stylesheet.insertRule(rule.trim(), stylesheet.cssRules.length);
  });
};